var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subitem",class:{ active: _vm.active },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.label))+"\n  "),(_vm.number)?_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }